<template>
  <svg width="34"
       height="34"
       viewBox="0 0 34 34"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_3254_5018)">
      <circle cx="17" cy="18" r="13" fill="url(#paint0_linear_3254_5018)" />
    </g>
    <path
      d="M16.9999 24.6666C13.3179 24.6666 10.3333 21.682 10.3333 18C10.3333 14.318 13.3179 11.3333 16.9999 11.3333C20.6819 11.3333 23.6666 14.318 23.6666 18C23.6666 21.682 20.6819 24.6666 16.9999 24.6666ZM16.9999 23.3333C18.4144 23.3333 19.771 22.7714 20.7712 21.7712C21.7713 20.771 22.3333 19.4145 22.3333 18C22.3333 16.5855 21.7713 15.2289 20.7712 14.2287C19.771 13.2285 18.4144 12.6666 16.9999 12.6666C15.5854 12.6666 14.2289 13.2285 13.2287 14.2287C12.2285 15.2289 11.6666 16.5855 11.6666 18C11.6666 19.4145 12.2285 20.771 13.2287 21.7712C14.2289 22.7714 15.5854 23.3333 16.9999 23.3333ZM17.6666 18H20.3333V19.3333H16.3333V14.6666H17.6666V18Z"
      fill="white" />
    <defs>
      <filter id="filter0_d_3254_5018"
              x="0"
              y="0"
              width="34"
              height="34"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0352941 0 0 0 0 0.905882 0 0 0 0 0.853647 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3254_5018" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3254_5018" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_3254_5018"
                      x1="26"
                      y1="5"
                      x2="8"
                      y2="31"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#29D3C9" />
        <stop offset="1" stop-color="#12B1A8" />
      </linearGradient>
    </defs>
  </svg>
</template>
